export const PAGES = [
  { key: "book", label: "Book a Session", path: "/book" },
  { key: "training", label: "LDA Training Hub", path: "/training" },
  { key: "league", label: "BPL League", path: "/league" },
  { key: "league-register", label: "League Registration", path: "/league/register" },
  { key: "league-overview", label: "League Overview", path: "/league/overview" },
  { key: "community", label: "Community", path: "/community" },
  { key: "vault", label: "Card Vault", path: "/vault" },
  { key: "tournaments", label: "Tournament Hub", path: "/tournaments" },
  { key: "tournament-hub", label: "Players Tournament Hub", path: "/tournaments/hub" },
  { key: "coaches-corner", label: "Coaches Corner", path: "/coaches-corner" },
  { key: "store", label: "Pro Shop / Store", path: "/store" },
  { key: "faq", label: "FAQ", path: "/faq" },
  { key: "court-board", label: "Live Court Board", path: "/court-board" },
  { key: "card-wars", label: "Bullpen: Card Wars (hidden game hub)", path: "/card-wars" },
];

export const AUDIENCES = [
  { value: "everyone", label: "Everyone" },
  { value: "members", label: "Members only (logged in)" },
  { value: "paid", label: "Paid members (VIP / Ace)" },
  { value: "coaches", label: "Coaches only" },
  { value: "tds", label: "Tournament Directors only" },
  { value: "admins", label: "Admins only" },
  { value: "off", label: "Off — hidden from everyone" },
];

export const canSeePage = (user, audience) => {
  if (!audience || audience === "everyone") return true;
  if (audience === "off") return false;
  if (user?.role === "admin") return true;
  if (audience === "members") return !!user;
  if (audience === "paid") return !!user?.membership && user.membership !== "free";
  if (audience === "coaches") return !!user?.is_coach;
  if (audience === "tds") return !!user?.is_td;
  return false;
};

export const pageForPath = (pathname) =>
  [...PAGES].sort((a, b) => b.path.length - a.path.length)
    .find((p) => pathname === p.path || pathname.startsWith(p.path + "/"));

export const ADMIN_SECTIONS = [
  { key: "section-dupr", label: "DUPR Integration (UAT)" },
  { key: "section-activity", label: "Live Activity" },
  { key: "section-broadcast", label: "Message All Members" },
  { key: "section-financials", label: "Financial Overview" },
  { key: "section-ai", label: "AI Insights & Promotions" },
  { key: "section-controls", label: "Financial Controls & Pricing" },
  { key: "section-membership-cards", label: "Membership Cards" },
  { key: "section-affiliates", label: "Affiliate Program" },
  { key: "section-bullion", label: "Bullion Coin" },
  { key: "section-card-vault", label: "Card Vault Command Center" },
  { key: "section-card-forge", label: "Card Forge — Bullpen Exclusives" },
  { key: "section-site-content", label: "Site Content Edits" },
  { key: "section-page-access", label: "Page Access Control" },
  { key: "section-moderation", label: "Community Moderation" },
  { key: "section-members", label: "Members & Alerts" },
  { key: "section-inventory", label: "Store Inventory" },
  { key: "section-slots", label: "Session Availability" },
  { key: "section-coaches", label: "Coaches System" },
  { key: "section-tournaments", label: "Tournament Hub" },
  { key: "section-reps", label: "Drill Rep Presets" },
  { key: "section-challenge", label: "1 Billion Rep Challenge" },
  { key: "section-bpl", label: "BPL League Management" },
];

export const SECTION_AUDIENCES = [
  { value: "admin", label: "Admin only" },
  { value: "coaches", label: "Admin + Coaches" },
  { value: "tds", label: "Admin + TDs" },
  { value: "both", label: "Admin, Coaches + TDs" },
];

export const canSeeSection = (user, raw, key) => {
  if (user?.role === "admin") return true;
  const v = raw ?? (key === "section-tournaments" ? "tds" : "admin");
  if (user?.is_coach && (v === "coaches" || v === "both")) return true;
  if (user?.is_td && (v === "tds" || v === "both")) return true;
  return false;
};
